import { render } from "../templates/conference-run-btn.html?vue&type=template&id=7ddaa07e"
import script from "./ConferenceRunBtn.vue?vue&type=script&lang=js"
export * from "./ConferenceRunBtn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__